import { pipe, prop } from 'ramda';

const selectAllUpgradeState = prop('upgrade');

const selectUpgradeModal = pipe(selectAllUpgradeState, prop('upgradeModal'));

export const selectUpgradeModalIsOpen = pipe(
  selectUpgradeModal,
  prop<boolean>('isOpen')
);
